/*
 * 卓上に出ているべきコミュニティカードの枚数。
 *
 * 中身は表示しない（アプリはボードの内容を知らない）。枚数だけを、離れた位置から
 * 数えられる大きさで示す。固定 px を使わず rem で組むので、中央ディスプレイ用の
 * 拡大テーマにそのまま追従する（要件11.9）。
 */

.row {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.35rem;
  justify-content: center;
  align-items: center;
}

.card {
  width: 1.9rem;
  aspect-ratio: 2 / 3;
  border-radius: 0.22rem;
  border: 0.14rem solid transparent;
  box-sizing: border-box;
}

/* すでに開いているべき枚数。裏面模様で「カードがある」ことを示す。 */
.dealt {
  border-color: var(--mantine-color-gray-0);
  background-image: repeating-linear-gradient(
    45deg,
    var(--mantine-color-blue-9) 0,
    var(--mantine-color-blue-9) 0.18rem,
    var(--mantine-color-blue-7) 0.18rem,
    var(--mantine-color-blue-7) 0.36rem
  );
  box-shadow: 0 0.1rem 0.3rem rgb(0 0 0 / 45%);
}

/*
 * まだ開かれない枚数。合計5枚のうち残りが何枚かが分かる。
 *
 * opacity で薄めるのではなく枠線の色で差を付ける。透過させると卓の背景（中央は明るい
 * teal）と混ざって、離れた位置から枠を数えられなくなる。
 */
.pending {
  border-color: var(--mantine-color-gray-6);
  border-style: dashed;
  background: transparent;
}

/* ハンドが無い、または完了した状態。枚数を主張しない。 */
.idle {
  opacity: 0.45;
}

/*
 * ショーダウンでまだ開き切っていない可能性がある場面を強調する。全員オールインで
 * 自動消化された直後は、卓上に1枚も出ていないことがある。
 */
.attention {
  animation: pulse 1.4s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgb(250 204 21 / 55%);
  }
  50% {
    box-shadow: 0 0 0 0.35rem rgb(250 204 21 / 0%);
  }
}
